import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Input,
} from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'

class AddOtherCostForm extends React.Component {
  render() {
    const open = get(this.props, 'open')
    const toggle = get(this.props, 'toggle')
    const handleInput = get(this.props, 'handleInput')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <HeaderForm toggle={ () => toggle() }>
          <HeadLabel>Add other cost</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container >
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Other Cost Name</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="other_cost_name"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

export default AddOtherCostForm

const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const HeaderForm = styled(ModalHeader)`
    font-family: 'Gotham-Bold' !important;
    font-size: 12px ;
`
const HeadLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 16px ;
    color: #AD2624;
    margin-left: 5px;
`
const TextLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 14px ;
    margin-left: 5px;
`




// WEBPACK FOOTER //
// ./src/components/project-information/form/add-other-cost/index.js